export enum ResponseStatus {
    Success,
    Failure,
    Exception
  }